import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-0"}],["path",{"d":"M7 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-1"}],["path",{"d":"M7 19a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-2"}],["path",{"d":"M16 12h.01","key":"svg-3"}],["path",{"d":"M8 12h.01","key":"svg-4"}],["path",{"d":"M16 19h.01","key":"svg-5"}]]

const IconBraille = createReactComponent('outline', 'braille', 'Braille', __iconNode);

export default IconBraille;